<nav class="jumpheader navbar navbar-light mx-auto">
  <a class="navbar-brand" href="#">
    @if (vm?.customLogo) {
      <img class="customer-logo" [src]="vm.customLogo" alt="" [attr.data-qa]="vm.qaCustomerLogo" />
    }
  </a>
  @if (showHelp) {
    <div class="help-action" [attr.data-qa]="vm.qaRequestHelp">
      <jui-button color="info" display="ghost" (click)="requestHelp()">{{ vm.helpLabel }} </jui-button>
    </div>
    } @if (vm?.showClose) {
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  }
</nav>
